import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src"]

import { computed, withDefaults } from "vue"
import GgmsLogo from "@/assets/icons/GGMS.svg"
import { useAgencyThemeStore } from "@/stores/agency-theme"

interface Props {
    to?: string
    logoClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GgmsLogo',
  props: {
    to: { default: "/" },
    logoClass: {}
  },
  setup(__props: any) {

const agencyThemeStore = useAgencyThemeStore()

const props = __props

const logo = computed(() => agencyThemeStore.agencyTheme?.logo?.url || GgmsLogo)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: props.to
  }, [
    _createElementVNode("img", {
      src: logo.value,
      alt: "ggms-logo",
      class: _normalizeClass(['max-h-[200px] max-w-[448px] bg-cover', _ctx.logoClass])
    }, null, 10, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})